var _process, _process2;
import { deprecatedOverlayDirections, mapPhysicalToLogicalDirections } from "./styles/mixins/overlays-deprecated.mjs";
import { mapLegacyToTextVariant } from "./utils.mjs";
import { variants as legacyTypeVariants } from "./components/Type/Type.mjs";

// For environment variables in webpack 5, see the "Runtime Errors" section of:
// https://webpack.mjs.org/migrate/5/#run-a-single-build-and-follow-advice

var muteEncoreWarnings = typeof MUTE_ENCORE_WARNINGS !== 'undefined' && MUTE_ENCORE_WARNINGS || typeof process !== 'undefined' && ((_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.MUTE_ENCORE_WARNINGS) || undefined;
var nodeEnv = typeof NODE_ENV !== 'undefined' && NODE_ENV || typeof process !== 'undefined' && ((_process2 = process) === null || _process2 === void 0 || (_process2 = _process2.env) === null || _process2 === void 0 ? void 0 : _process2.NODE_ENV) || undefined;
export function warn(message) {
  if (muteEncoreWarnings === 'true' || nodeEnv === 'production') {
    return;
  }

  // eslint-disable-next-line no-console
  console.warn(message);
}
export function deprecatedPropWarning(oldProp, component, message) {
  warn("The ".concat(oldProp, " prop in ").concat(component, " has been deprecated. ").concat(message || ''));
}
export function renamedPropWarning(oldProp, newProp, component, additionalInfo) {
  warn("The ".concat(oldProp, " prop in ").concat(component, " has been deprecated. Please use ").concat(newProp, " instead. ").concat(additionalInfo || ''));
}
export function newRequiredPropWarning(component, newProp, additionalInfo) {
  warn("Using ".concat(component, " without the ").concat(newProp, " prop is deprecated usage. ").concat(additionalInfo || ''));
}
export function componentDeprecationWarning(oldComponent, newComponent, version, additionalInfo) {
  warn("".concat(oldComponent, " is deprecated and will be removed in ").concat(version, ". Please use ").concat(newComponent, " instead. ").concat(additionalInfo || ''));
}
export function physicalDirectionWarning(direction, component) {
  // 'top' & 'bottom' have kept the same names
  var deprecatedDirections = Object.keys(deprecatedOverlayDirections).filter(function (dir) {
    return dir !== 'top' && dir !== 'bottom';
  });
  if (deprecatedDirections.includes(direction)) {
    return renamedPropWarning(direction, mapPhysicalToLogicalDirections(direction), component, 'This allows us to support localization.');
  }
  return null;
}

/** Console warning for legacy type variants, with migration suggestion */
export var warnLegacyTypeVariant = function warnLegacyTypeVariant(component, variant, weight) {
  if (Object.keys(legacyTypeVariants).includes(variant)) {
    if (weight) {
      warn("The variant \"".concat(variant, "\" and the 'weight' prop are deprecated in ").concat(component, ". Please use the variant \"").concat(mapLegacyToTextVariant(variant, weight), "\"."));
    } else {
      warn("The variant \"".concat(variant, "\" is deprecated in ").concat(component, ". Please use the variant \"").concat(mapLegacyToTextVariant(variant), "\"."));
    }
  }
};

/** Console warning that portals must have a color theme class passed in */
export var warnPortalThemeClass = function warnPortalThemeClass(component, isUsingPortal, className) {
  var colorThemeRegex = /encore-[a-z-]+-theme$/;
  var hasThemeClass = className ? className === null || className === void 0 ? void 0 : className.match(colorThemeRegex) : [];
  var hasColorTheme = !!(hasThemeClass && hasThemeClass.length);
  if (isUsingPortal && !hasColorTheme) {
    warn("You must provide an Encore color theme (e.g. 'encore-light-theme') in the className prop for ".concat(component, ", as it is rendered in a portal and cannot reference your root level theme class. Otherwise, a fallback theme will be used, but this will be removed in the next major release."));
    return true;
  }
  return false;
};